<template>
  <div
    class="btn-wrap"
    :title="disabled ? title : ''"
    :class="{ disabled: disabled }"
    @click="click($event)"
    :style="{
      width: width,
      height: height,
    }"
    v-ripple="!disabled"
  >
    <img
      v-if="disabled"
      :src="disableImg"
      alt="img-disable"
      draggable="false"
    />
    <img v-else-if="img" class="bg" :src="img" alt="img" draggable="false" />
    <div
      class="btn d-flex align-center justify-center"
      :style="{
        '--color': disabled ? '#d6d6d6' : color,
      }"
    >
      <div v-if="prependIcon" class="d-flex align-center">
        <img :src="prependIcon" alt="prepend-icon" draggable="false" />
      </div>
      <div
        class="d-flex align-center"
        :style="{
          color: fontColor.includes('fff') || !disabled ? fontColor : '#d6d6d6',
          'font-weight': fontWeight,
        }"
      >
        {{ name }}
      </div>
      <div v-if="appendIcon" class="d-flex align-center">
        <img :src="appendIcon" alt="append-icon" draggable="false" />
      </div>
    </div>
  </div>
</template>

<!-- 
  purple1 #693CE1
  purple2 #823264
  red #C83C50
  blue #0085CF
  gray2 #999999
  gray3 #d6d6d6 disabled
  black #333333
 -->

<script>
export default {
  props: {
    /** 버튼 text */
    name: {
      type: String,
      default: () => "",
    },
    /** 버튼 넓이 */
    width: {
      type: String,
      default: () => "",
    },
    /** 버튼 높이 */
    height: {
      type: String,
      default: () => "",
    },
    /** 버튼 활성화/비활성화 */
    disabled: {
      type: Boolean,
      default: () => false,
    },
    /** 버튼 비활성화 img */
    disableImg: {
      type: String,
      default: () => "",
    },
    /** 버튼 메인 색상 */
    color: {
      type: String,
      default: () => "",
    },
    /** 버튼 텍스트 앞쪽 아이콘 */
    prependIcon: {
      type: String,
      default: () => "",
    },
    /** 버튼 텍스트 뒤쪽 아이콘 */
    appendIcon: {
      type: String,
      default: () => "",
    },
    /** 폰트 색상 (기본: color) */
    fontColor: {
      type: String,
      default: () => "",
    },
    /** 폰트 weight */
    fontWeight: {
      type: String,
      default: () => "500",
    },
    /** 배경 이미지 */
    img: {
      type: String,
      default: () => "",
    },
    /** 툴팁 */
    title: {
      type: String,
      default: () => "",
    },
  },
  methods: {
    click(e) {
      if (this.disabled) return;
      this.$emit("click", e);
    },
  },
};
</script>

<style scoped>
.btn-wrap {
  position: relative;
  cursor: pointer;
}

.btn-wrap > * {
  user-select: none;
}

.btn-wrap:hover .bg {
  filter: drop-shadow(0px 2px 5px rgba(0, 0, 0, 0.15));
}

.btn-wrap.disabled {
  cursor: unset;
}

.btn-wrap .bg {
  overflow: hidden;
  transition: 0.1s;
}

.btn-wrap .btn {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.btn-wrap.disabled .btn {
  color: #d6d6d6 !important;
}

.btn-wrap.disabled .btn.fill {
  background-color: #d6d6d6 !important;
  color: #ffffff !important;
}
</style>

<style>
.btn-wrap .v-ripple__container {
  border-radius: 7px;
}
</style>
